module.exports = __webpack_public_path__ + "img/img3.91cee2e5.png";